var exports = {
  "kL": "x620889e6--7d70d7--container",
  "nf": "x620889e6--7d70d7--link",
  "Kk": "x620889e6--7d70d7--icon",
};

module.exports = exports;
